import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { Button, Col, Form, Input, Row, Spin, Typography } from 'antd';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { PostUserLoginData } from '../../../features/auth/auth.api';
import { signIn } from '../../../features/auth/auth.state';
import styles from './LoginPage.module.css';
import { AppDispatch } from '../../../index';

const LoginPage: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch: AppDispatch = useDispatch();

  const [form] = Form.useForm();
  const [formSubmitting, setFormSubmitting] = useState<boolean>(false);

  const onFinish = async (values: PostUserLoginData) => {
    setFormSubmitting(true);
    const response = await dispatch(signIn(values));
    setFormSubmitting(false);

    if (signIn.fulfilled.match(response)) {
      const query = new URLSearchParams(location.search);
      const redirectTo = query.get('redirectUri') || '/';
      history.push(redirectTo);
    }
  };

  return (
    <Row justify='center' align='middle' className={styles.root}>
      <Col xs={24} sm={18} md={12} lg={6}>
        <Typography.Title level={3} style={{ textAlign: 'center' }}>
          VR CMS
        </Typography.Title>
        <Spin spinning={formSubmitting}>
          <Form size='large' form={form} layout='vertical' onFinish={onFinish} validateTrigger='onBlur'>
            <Form.Item
              label='Email'
              name='email'
              rules={[
                {
                  required: true,
                  type: 'email',
                },
              ]}
            >
              <Input type='email' autoComplete='email' />
            </Form.Item>
            <Form.Item
              label='Password'
              name='password'
              rules={[
                {
                  required: true,
                  message: 'Please input your Password!',
                },
              ]}
            >
              <Input.Password
                type='password'
                placeholder='input password'
                autoComplete='current-password'
                iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
              />
            </Form.Item>
            <Form.Item>
              <Button type='primary' htmlType='submit' size='large' style={{ width: '100%' }}>
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      </Col>
    </Row>
  );
};

export default LoginPage;
